import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

const QuestionLabelStyle = ({ noLabel }) => ({
  marginBottom: noLabel ? '0px' : '8px',
  display: 'flex',
  gap: '5px',
  alignItems: 'center'
});

export const QuestionLabelStyled = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'noLabel'
})(QuestionLabelStyle);
